module.exports = __webpack_public_path__ + "static/media/BackgroundImage.279351b6.svg";